import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import './index.scss';
function ViewMoreCard(props) {
    const { moreUrl } = props;
    const content = !moreUrl ? "更多内容敬请期待" : "滑动查看更多";
    return <View className="view-more-card">
      <View className="view-more-card__content">
        <View>
            {content.split('').map((item, index) => <Text className="view-more-card__text" key={index} style={{
        fontSize: moreUrl ? '24rpx' : '18rpx',
        lineHeight: moreUrl ? '30rpx' : '24rpx'
    }}>{item}</Text>)}
        </View>
        <Image x-if={moreUrl} source={{
        uri: 'https://p0.meituan.net/ingee/b149f384a36591e7e72a062dbaf5faef1193.png'
    }} className="view-more-card__icon" style={{
        width: '30rpx',
        height: '30rpx'
    }}/>
      </View>

    </View>;
}
export default memo(ViewMoreCard);
